module.exports = __webpack_public_path__ + "static/fun-time/games/page006_game0/audio//M_Fantastic.mp3";